(() => {
  if (window.mcTechPantsGalleryLightbox) return;
  window.mcTechPantsGalleryLightbox = true;

  const selector = '[maison-test-id="MC_PDP_BENEFITGALLERY_ICON"]';
  const connected = new WeakSet();
  const isVisible = (element) => element?.isConnected && element.getClientRects().length > 0 && getComputedStyle(element).display !== 'none';

  // Capture before the theme opens PhotoSwipe, so the first slide has its hooks.
  document.addEventListener('lightbox:open', (event) => {
    const gallery = event.target.closest?.('product-gallery');
    if (!gallery?.closest('[data-mc-tech-pants-section]')) return;
    if (![...gallery.querySelectorAll(selector)].some(isVisible)) return;

    const lightbox = gallery.photoswipe;
    if (!lightbox || connected.has(lightbox)) return;
    connected.add(lightbox);

    const overlays = new Map();
    let visibilityObserver;

    const removeOverlay = (content) => {
      overlays.get(content)?.remove();
      overlays.delete(content);
    };

    const syncOverlay = (content, width = content.displayedImageWidth, height = content.displayedImageHeight) => {
      const source = content.data.thumbnailElement?.closest('.product-gallery__media')?.querySelector(selector);
      if (!content.slide || !isVisible(source) || !(width > 0 && height > 0)) {
        removeOverlay(content);
        return;
      }

      let overlay = overlays.get(content);
      if (!overlay) {
        overlay = source.cloneNode(true);
        overlay.setAttribute('data-mc-tech-lightbox-benefits', '');
        // The source is the experiment gate; the lightbox lives outside its section.
        overlay.style.display = 'block';
        overlay.style.inset = '0 auto auto 0';
        overlays.set(content, overlay);
      }

      overlay.style.width = `${width}px`;
      overlay.style.height = `${height}px`;
      // PhotoSwipe changes image resolution at the end of a zoom. Scale typography
      // with that resolution so labels do not jump when the image is resampled.
      const sourceWidth = source.getBoundingClientRect().width;
      if (sourceWidth > 0) {
        const labelSize = parseFloat(getComputedStyle(source.querySelector('.mc-tech-gallery-benefits__label')).fontSize);
        overlay.style.setProperty('--mc-tech-gallery-label-size', `${labelSize * width / sourceWidth}px`);
      }
      if (overlay.parentElement !== content.slide.container) {
        content.slide.container.appendChild(overlay);
      }
    };

    lightbox.on('afterSetContent', ({ slide }) => syncOverlay(slide.content));
    lightbox.on('contentAppend', ({ content }) => syncOverlay(content));
    lightbox.on('contentResize', ({ content, width, height }) => syncOverlay(content, width, height));
    lightbox.on('contentRemove', ({ content }) => removeOverlay(content));
    lightbox.on('contentDestroy', ({ content }) => removeOverlay(content));

    lightbox.on('beforeOpen', () => {
      if (!('ResizeObserver' in window)) return;
      visibilityObserver?.disconnect();
      visibilityObserver = new ResizeObserver(() => {
        for (const content of overlays.keys()) syncOverlay(content);
      });
      gallery.querySelectorAll(selector).forEach((source) => visibilityObserver.observe(source));
    });

    lightbox.on('destroy', () => {
      visibilityObserver?.disconnect();
      visibilityObserver = null;
      for (const content of overlays.keys()) removeOverlay(content);
    });
  }, true);
})();
